import { render, staticRenderFns } from "./MyCompanyArticlesNew.vue?vue&type=template&id=f8121696&scoped=true&"
import script from "./MyCompanyArticlesNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyArticlesNew.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyArticlesNew.vue?vue&type=style&index=0&id=f8121696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8121696",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
